window.addEventListener("DOMContentLoaded", () => {
  const body = document.querySelector("body");
  const lockPaddingValue = window.innerWidth - body.offsetWidth + "px";
  const wrapper = document.querySelector(".wrapper");
  const burger = document.querySelector(".js-burger");
  const menu = document.querySelector(".main-menu");
  const header = document.querySelector(".header");

  if(!burger)
    return;
  burger.addEventListener("click", () => {
    const menuActive = document.querySelector(".main-menu.active");
    if (menuActive) {
      body.style.overflow = "";
      bodyUnLock();
    } else {
      body.style.overflow = "hidden";
      bodyLock();
    }
    burger.classList.toggle("active");
    menu.classList.toggle("active");
  });

  function bodyLock() {
    header.style.paddingRight = lockPaddingValue;
    wrapper.style.paddingRight = lockPaddingValue;
  }

  function bodyUnLock() {
    header.style.paddingRight = "";
    wrapper.style.paddingRight = "";
  }

  const accordeonsDesktop = document.querySelectorAll(
    ".menu-item-has-children"
  );
  if (accordeonsDesktop.length > 0) {
    accordeonsDesktop.forEach((accordeon) => {
      const accordeonHeader = accordeon.querySelector("a");
      if (accordeonHeader.nextElementSibling) {
        accordeonHeader.addEventListener("click", (e) => {
          e.preventDefault();
          _slideToggle(accordeonHeader.nextElementSibling);
          e.target.classList.toggle("active");
        });
      }
    });
  }
});
let _slideUp = (target, duration = 500) => {
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
    target.classList.remove("_slide");
  }, duration);
};
let _slideDown = (target, duration = 500) => {
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";

  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  target.style.removeProperty("padding-top");
  target.style.removeProperty("padding-bottom");
  target.style.removeProperty("margin-top");
  target.style.removeProperty("margin-bottom");
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
    target.classList.remove("_slide");
  }, duration);
};

let _slideToggle = (target, duration = 500) => {
  if (!target.classList.contains("_slide")) {
    target.classList.add("_slide");
    if (window.getComputedStyle(target).display === "none") {
      return _slideDown(target, duration);
    } else {
      return _slideUp(target, duration);
    }
  }
};


